// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3ebjH","disabled":"FileBtn_disabled__5x3xt","warn":"FileBtn_warn__1JYX0","fade":"FileBtn_fade__2eeX8"};